import { ChevronDown } from "lucide-react";
import type { Ref, SelectHTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";
import { useFieldControlProps } from "./field-context";
import { controlBase, controlSizes, type ControlSize } from "./control-styles";

export type SelectOptionItem = { value: string; label: string; disabled?: boolean };

type SelectProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, "size"> & {
  /** Opções simples; ou passe <option> como children. */
  options?: SelectOptionItem[];
  /** Opção vazia inicial ("Selecione…"). */
  placeholder?: string;
  size?: ControlSize;
  invalid?: boolean;
  ref?: Ref<HTMLSelectElement>;
};

/** Select nativo estilizado (acessível e leve; bom no mobile). */
export function Select({ options, placeholder, size = "md", invalid, className, children, ...props }: SelectProps) {
  const field = useFieldControlProps(props, invalid);
  return (
    <div className={cn("relative w-full", className)}>
      <select
        {...props}
        id={field.id}
        aria-describedby={field["aria-describedby"]}
        aria-invalid={field["aria-invalid"]}
        required={field.required}
        disabled={field.disabled}
        className={cn(controlBase, controlSizes[size], "w-full cursor-pointer appearance-none pr-9", field.invalid && "border-danger")}
      >
        {placeholder != null ? <option value="">{placeholder}</option> : null}
        {options?.map((o) => (
          <option key={o.value} value={o.value} disabled={o.disabled}>
            {o.label}
          </option>
        ))}
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-fg-subtle" aria-hidden />
    </div>
  );
}
